export default {
	state: {
		user: {},
		token: false,
		channel: [],// 所有渠道
		platform: [], // 所有平台
		userchannel: [],// 需要显示的渠道
	},
	getters: {

	},
	mutations: {
		//初始化用户信息
		initUser(state) {
			let user = window.sessionStorage.getItem('user')
			if (user) {
				state.user = JSON.parse(user)
				state.token = state.user.token
			}
		},
		//登录方法
		login(state, user) {
			//保存登录状态
			state.user = user
			state.token = user.token
			window.sessionStorage.setItem('user', JSON.stringify(state.user))
			window.sessionStorage.setItem('token', state.token)
		},
		//退出登录
		logout(state) {
			//清除状态
			state.user = {}
			state.token = false
			//清除本地存储
			window.sessionStorage.clear()
		},
		// 添加渠道
		addchannel(state, data) {
			state.channel = data;
		},
		// 添加平台
		addplatform(state, data) {
			state.platform = data;
		},
		// 获取当前用户需要显示的渠道
		showchanne(state) {
			if (state.channel && state.channel.length > 0) {
				let platform_type = null;
				if (state.user && state.user.platform_type) {
					platform_type = state.user.platform_type
				} else {
					let data = JSON.parse(window.sessionStorage.getItem("user"));
					platform_type = data.platform_type
				}
				if (platform_type == 0) {
					// 所有渠道能看
					state.userchannel = state.channel
				} else {
					// 不是就去拿对应的渠道号
					if (platform_type == "" || platform_type == null || platform_type == undefined) {
						return
					}
					let arr = []
					for (let i in state.channel) {
						if (state.channel[i].platform_type == platform_type) {
							arr.push(state.channel[i])
						}
					}
					state.userchannel = arr
				}
			}
			return state.userchannel
		},
	},
	actions: {

	}
}